import React, { forwardRef, useId } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Icon } from "../Icon/Icon.component";
import { DA_InputWrapper } from "../InputWrapper/InputWrapper.component";
import { DA_InputWrapperProps } from "../InputWrapper/InputWrapper.component";
import { DA_InputProps } from "./Input.props";
import S from "./Input.module.scss";

type DA_InputWithWrapperProps = DA_InputProps & Omit<DA_InputWrapperProps, "forId">;

export const DA_Input = forwardRef<HTMLInputElement, DA_InputWithWrapperProps>((props, ref) => {
    const generatedId = useId();

    const {
        label,
        id,
        name,
        helperText,
        tooltip,
        icon,
        defaultValue,
        className,
        inputClassName,
        invalid,
        highlighted,
        showAsFocused,
        readOnly,
        onChange,
        type,
        inputMode,
        pattern,
        rightText,
        onBlur,
        ...rest
    } = props;

    return (
        <DA_InputWrapper
            label={label}
            forId={id || generatedId}
            helperText={helperText}
            tooltip={tooltip}
            invalid={invalid}
            className={className}
        >
            <div
                className={cn(
                    S.inputWrapper,
                    icon && S.hasIcon,
                    rest.disabled && S.disabled,
                    invalid && S.invalid,
                    showAsFocused && S.showAsFocused,
                    highlighted && S.highlighted,
                    className
                )}
            >
                {/** Input */}
                <input
                    id={id || generatedId}
                    name={name || id}
                    readOnly={readOnly}
                    ref={ref}
                    defaultValue={defaultValue}
                    className={cn(S.input, inputClassName)}
                    onChange={({ target }) => (onChange ? onChange(target.value) : null)}
                    type={type}
                    onBlur={onBlur}
                    inputMode={type === "number" ? inputMode || "numeric" : inputMode}
                    pattern={type === "number" ? pattern || "[0-9]*" : pattern}
                    {...rest}
                />

                {rightText && <div className={S.rightText}>{rightText}</div>}
            </div>

            {/** Icon */}
            {icon && <DA_Icon name={icon} className={S.icon} />}
        </DA_InputWrapper>
    );
});
DA_Input.displayName = "DA_Input";
